import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useField } from "formik";

const BInputGroupSelectField = (props) => {
    const {
        controlId,
        dropDownLabel,
        label,
        icon,
        onClick,
        dataLabel,
        dataLabel2,
        dataValue,
        size,
        appendStart,
        data,
        ...rest
    } = props;
    const [field, meta] = useField(props);

    return (
        <Form.Group controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <InputGroup className="mb-3">
                {appendStart && (
                    <InputGroup.Prepend>
                        <InputGroup.Text id={controlId} onClick={onClick} className="theme-icon">
                            {icon}
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                )}
                <Form.Control
                    {...rest}
                    {...field}
                    as="select"
                    isInvalid={meta.error && meta.touched}
                    isValid={!meta.error && meta.touched}
                    size={size}
                >
                    <option>{dropDownLabel}</option>
                    {data?.map((item) => (
                        <option value={item[dataValue]} key={item[dataLabel]}>
                            {item[dataLabel]}
                            {dataLabel2 ? `- ${item[dataLabel2]}` : ""}
                        </option>
                    ))}
                </Form.Control>
                {meta.error && meta.touched ? (
                    <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                ) : null}
                {!appendStart && (
                    <InputGroup.Prepend>
                        <InputGroup.Text id={controlId} onClick={onClick} className="theme-icon">
                            {icon}
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                )}
            </InputGroup>
        </Form.Group>
    );
};

BInputGroupSelectField.defaultProps = {
    data: [],
    dropDownLabel: "",
    size: "md",
    dataLabel: "name",
    dataValue: "id",
    dataLabel2: "",
    onClick: null,
    icon: null,
    appendStart: true
};

export default BInputGroupSelectField;
